import { RootState } from '../../store';

export const getDepartmentSelector = (state: RootState) => state?.departmentReducer?.department;
